import React from "react";
import styled from "styled-components";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import { FontSize } from "@themes/Fonts";
import Styles from "@themes/Styles";
import { useAppModeContext } from "../LifeAtApp/AppModeContext";
import ChevronLeftIcon from "/resources/icons/ChevronLeftArrow.svg";

const PlannerMobileInfoPageContainer = styled.div`
    height: 100%;
    width: 100%;

    display: flex;
    position: fixed;
    z-index: ${Styles.zIndexTopNavigation};
    top: 0;
    flex-direction: column;

    background-color: ${(props) => props.theme.backgroundPrimary};
`;

const ContentContainer = styled.div`
    display: flex;
    height: 100%;

    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 35px;

    padding: 20px;
    overflow: auto;
`;

const Header = styled.div`
    width: fit-content;
    font-size: 24px;
    font-weight: 550;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.textColorPrimary};
    white-space: pre-line;
`;

const SubHeader = styled.div`
    width: fit-content;
    font-size: ${FontSize.medium};
    color: ${({ theme }) => theme.textColorPrimary};
    white-space: pre-line;
`;

const HeaderRow = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: 8px 4px;
`;

const StyledChevronLeftIcon = styled(ChevronLeftIcon)`
    fill: ${(props) => props.theme.iconColor};
`;

const PromoImg = styled.img`
    width: 100%;
    max-width: 500px;
`;

const PAGE_HEADER = "Try planner mode\n on your desktop";
const PAGE_SUB_HEADER = "Work and life tasks in one place. Try it out\n on your desktop app or browser";
const BACK_BUTTON_LABEL = "Back";
const LEARN_MORE_BUTTON_LABEL = "Learn more";
const LEARN_MORE_LINK = "https://www.lifeat.com/";
const PLANNER_PROMO_IMG =
    "https://firebasestorage.googleapis.com/v0/b/lifeatspaces-prod.appspot.com/o/images%2Fplanner%2Fplanning-view-promo.png?alt=media&token=c69affd4-ce41-4474-8e3a-60a96562014b&_gl=1*178o733*_ga*MjA1MTU1NDI4Ny4xNjU1OTIyOTQ5*_ga_CW55HF8NVT*MTY5Njg5NjA5Mi4yNTUuMS4xNjk2ODk3OTQ2LjIzLjAuMA..";
function PlannerMobileInfoPage() {
    const { setAppMode } = useAppModeContext();

    return (
        <PlannerMobileInfoPageContainer>
            <HeaderRow>
                <LifeAtButtonV2 variant={"ghost"} onClick={() => setAppMode("focus")}>
                    <StyledChevronLeftIcon />
                    {BACK_BUTTON_LABEL}
                </LifeAtButtonV2>
            </HeaderRow>
            <ContentContainer>
                <div>
                    <Header>{PAGE_HEADER}</Header>
                    <SubHeader>{PAGE_SUB_HEADER}</SubHeader>
                </div>
                <PromoImg src={PLANNER_PROMO_IMG} alt={"planner preview"} />
                <LifeAtButtonV2 variant={"outline"} href={LEARN_MORE_LINK}>
                    {LEARN_MORE_BUTTON_LABEL}
                </LifeAtButtonV2>
            </ContentContainer>
        </PlannerMobileInfoPageContainer>
    );
}

export default PlannerMobileInfoPage;
